// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2589":"d6fdf0fb","7116":"07626bd9","8921":"4432e7e9","9103":"b9ea4917"}[chunkId] + ".css";
};